export const HomeObjOne = {
  colorBg: "black",
  imgStart: false,
  start: false,

  headline: "About me",
  subtitle: "",
  description: `Hi there, thanks for your visit on my website.
   
  My name is Wendelin Steiner and I enjoy hiking, nature, photography and drones. So why not combine altogether? This and the current Covid situation \u{1F605} was the birth of the idea behind Wanderruf (German word for "call to wander"). 
  The idea to explore Switzerland, to capture the beauty of the nature and to share it. 
  I would be delighted if my pictures and videos serve as inspiration for your next adventure.
  
  Don't hesitate to contact me for a collaboration or with suggestions for places worth exploring.
  `,
  buttonLabel: "Contact",

  img: require("../../images/profile.jpeg").default,
  alt: "Image of website owner",
};

export const SocialMediaData = {
  headline: "Social Media",
  description: `Find below my lastest activities.
    Follow me for more pictures and videos.`,
};

export const MetaData = {
  title: `WANDERRUF | Nature and Drone Photography in Switzerland`,
  description: `Discover the most beautiful hikes and places in Switzerland. An inspiration for your next adventure.`,
  author: `Wendelin Steiner`,
  img: require("../../images/wanderruf.jpeg").default,
  twitterUsername: `wendelinsteiner`,
};
